export default __webpack_public_path__ + "static/media/pen-nib.18460abd.svg";